module.exports = __webpack_public_path__ + "img/91_5.ffe93dd6.png";